import { styled } from '@mui/material';

export const LocationGroupTitle = styled('div')`
  position: relative;
  margin-top: 5px;
  padding: 8px 18px;
  font-size: 12px;
  line-height: 1.35em;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.grey[800]};

  &::before {
    content: '';
    position: absolute;
    left: 8px;
    right: 8px;
    top: -5px;
    height: 1px;
    background-color: ${({ theme }) => theme.palette.grey[200]};
  }
  ${({ theme }) => theme.breakpoints.down('md')} {
    padding: 8px;
  }
`;
